import script from "./SheetFlipAsis.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetFlipAsis.vue?vue&type=script&setup=true&lang=ts"

import "./SheetFlipAsis.vue?vue&type=style&index=0&id=e450fea8&lang=css"

const __exports__ = script;

export default __exports__